import Spinner from "react-bootstrap/Spinner";

function BSLoader(props) {
  return (
    <Spinner animation="border" role="status" {...props}>
      <span className="visually-hidden">Loading...</span>
    </Spinner>
  );
}

export default BSLoader;
